import React from "react";
import styled from "styled-components";

const DateDisplay = ({ date, isToday, isClickable, onClick }) => (
    <DateWrapper $isToday={isToday} $isClickable={isClickable} onClick={onClick}>
        <DateText $isToday={isToday}>{date}</DateText>
    </DateWrapper>
);

const Counter = ({ count }) => (
    <CounterBox>{count}</CounterBox>
);

const DateRow = ({ date, isToday, sessionsCount, viewType, weekNum, onWeekClick }) => {
    const isWeekView = viewType === 'week';
    
    const handleWeekClick = () => {
        if (isWeekView && onWeekClick && weekNum) {
            onWeekClick(weekNum);
        }
    };
    
    return (
        <EntryContainer>
            <DateDisplay 
                date={date} 
                isToday={isToday} 
                isClickable={isWeekView}
                onClick={handleWeekClick}
            />
            <Counter count={sessionsCount} />
        </EntryContainer>
    );
};

const EntryContainer = styled.section`
  display: flex;
  width: 100%;
  gap: 20px;
  justify-content: space-between;
  margin-top: 9px;
  margin-bottom: 10px;
`;

const DateWrapper = styled.div`
    display: flex;
    gap: 5px;
    font-size: 17px;
    color: ${props => props.$isToday ? '#fff' : '#969a97'};
    font-weight: ${props => props.$isToday ? 'bold' : '700'};
    background-color: ${props => props.$isToday ? '#9333ea' : 'transparent'};
    border-radius: 5px;
    padding: ${props => props.$isToday ? '0px 9px' : '0 9px'};
    cursor: ${props => props.$isClickable ? 'pointer' : 'default'};
    transition: all 0.2s ease;
    
    ${props => props.$isClickable && `
        &:hover {
            background-color: ${props.$isToday ? '#6a4ab3' : '#f0f0f0'};
            transform: translateY(-1px);
        }
    `}
`;

const DateText = styled.time`
  font-family: Inter, sans-serif;
  margin: auto 0;
`;

const CounterBox = styled.span`
    background-color: #e5e7eb;
    color: #4b5563;  
    width: 24px;
    height: 24px;
    padding: 0.25rem 0.5rem; 
    display: flex;
    align-items: center;
    justify-content: center;
    font: 500 13px Inter, sans-serif;
    font-weight: 600;
    margin-right: 10px;
    border-radius: 9999px;
`;

export default DateRow;